function Title(props) {
  return (
    <div className="title">
      <div className="title-head d-flex align-items-center">
        <p className="m-0"></p>
        <h2 className="mb-0">{props.title}</h2>
      </div>
      <div>{props.text}</div>
    </div>
  )
}
export default Title;